import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    SimpleForm,
    TextInput,
    Edit,
    Create
} from 'react-admin';

export const IconList = (props) => (
    <List {...props} title="Icon Prod Table">
        <Datagrid rowClick="edit" >
            <TextField source="id" label="Id" />
            <TextField source="Icon" label="Icon" />
            <TextField source="Prefix" label="Prefix" />
            <TextField source="IconName" label="IconName" />
            <EditButton />
        </Datagrid>
    </List >
);

export const IconEdit = (props) => (
    <Edit {...props} title="Icon Prod Table">
        <SimpleForm>
            <TextField source="id" label="Id" />
            <TextInput source="Icon" label="Icon" />
            <TextInput source="Prefix" label="Prefix" />
            <TextInput source="IconName" label="IconName" />
        </SimpleForm>
    </Edit >
);

export const IconCreate = (props) => (
    <Create {...props} title="Icon Prod Table">
        <SimpleForm >
            <TextInput source="Icon" label="DBIcon" />
            <TextInput source="Prefix" label="FAPrefix" />
            <TextInput source="IconName" label="FAIconName" />
        </SimpleForm>
    </Create >
);